// <head> metadata for CurrentThankYouPage (https://www.dbos.dev/current-thank-you).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Current Thank You',
    },
    {
      property: 'og:title',
      content: 'Current Thank You',
    },
    {
      name: 'twitter:title',
      content: 'Current Thank You',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/current-thank-you',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
